import { useState, useCallback, useRef } from 'react';
import apiService from '../services/apiService';

export const useChat = (language = 'es') => {
  const [messages, setMessages] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const conversationHistory = useRef([]);

  const addMessage = useCallback((type, content) => {
    const newMessage = {
      id: Date.now(),
      type,
      content,
      timestamp: new Date().toISOString(),
    };
    
    setMessages(prev => [...prev, newMessage]);
    
    conversationHistory.current.push({
      type,
      content
    });
    
    return newMessage;
  }, []);

  const sendMessage = useCallback(async (message) => {
    if (!message.trim()) return;

    setError(null);
    setIsLoading(true);

    addMessage('user', message);

    try {
      const response = await apiService.sendMessage(
        message, 
        language, 
        conversationHistory.current
      );

      if (response.success) {
        addMessage('ai', response.response);
      } else {
        throw new Error('Invalid API response');
      }

    } catch (err) {
      console.error('Error sending message:', err);
      setError(err.message || 'Error sending message');
      
      addMessage('ai', language === 'es' 
        ? 'Disculpa, estoy teniendo problemas técnicos. Por favor, intenta de nuevo.'
        : 'Sorry, I\'m having technical issues. Please try again.'
      );
    } finally {
      setIsLoading(false);
    }
  }, [language, addMessage]);

  const clearMessages = useCallback(() => {
    setMessages([]);
    conversationHistory.current = [];
    setError(null);
  }, []);

  const initializeChat = useCallback(() => {
    const welcomeMessages = {
      es: "¡Hola! Soy MindWise AI, tu asistente psicológico virtual. Estoy aquí para escucharte y apoyarte. ¿Cómo te sientes hoy? ¿Hay algo específico en lo que te gustaría que te ayude a reflexionar?",
      en: "Hello! I'm MindWise AI, your virtual psychological assistant. I'm here to listen and support you. How are you feeling today? Is there something specific you'd like me to help you reflect on?"
    };

    setTimeout(() => {
      addMessage('ai', welcomeMessages[language]);
    }, 1000);
  }, [language, addMessage]);

  return {
    messages,
    isLoading,
    error,
    sendMessage,
    clearMessages,
    initializeChat
  };
};